export const SESSION_TIMEOUT_MINUTES = 10;
export const PIN_MAX_ATTEMPTS = 5;
export const PRIDE_MAX_REGENERATIONS = 3;
export const PHOTO_MAX_WIDTH = 1920;
export const PHOTO_QUALITY = 0.80;
export const PHOTO_FORMAT = 'webp';
export const LASER_INACTIVE_DAYS = 45;
export const LASER_CHECKUP_INTERVAL = 6;
